import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React from 'react';
import { uicolors } from '../../../../theme';

export function ProgressBar(props: { progress?: number }) {
  return (
    <Stack
      spacing={0.2}
      direction="row"
      alignItems="center"
      sx={{ width: '100%' }}
    >
      {[1, 2, 3].map((step) => {
        const completed = props.progress && step <= props.progress;

        let backgroundColor: React.CSSProperties['backgroundColor'] =
          uicolors.red[600] + '55';
        if (completed) {
          backgroundColor = uicolors.red[600];
        }

        return (
          <Box
            key={step}
            sx={{
              p: 0.2,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor,
              ':first-child': {
                borderRadius: ' 4px 0 0 4px',
              },
              ':last-child': {
                borderRadius: '0 4px 4px 0',
              },
            }}
          >
            <Box
              sx={{
                borderRadius: 50,
                border: '1px solid',
                borderColor: uicolors.red[800],
                backgroundColor: uicolors.black[700],
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 22,
                width: 22,
              }}
            >
              {completed ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M10 18H8v-2h2v2Zm-2-2H6v-2h2v2Zm4-2v2h-2v-2h2Zm-6 0H4v-2h2v2Zm8 0h-2v-2h2v2Zm2-2h-2v-2h2v2Zm2-2h-2V8h2v2Zm2-2h-2V6h2v2Z" />
                </svg>
              ) : (
                <Box sx={{ fontFamily: 'Racing Sans One' }}>{step}</Box>
              )}
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}
